import { OnInit, } from '@angular/core';
import { DatastoreCollection, } from '@freelancer/datastore';
import { ModalService } from '@freelancer/ui';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { VerticalAlignment } from '@freelancer/ui/grid';
import { HeadingSize } from '@freelancer/ui/heading';
import { IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { ModalSize } from '@freelancer/ui/modal';
import { FontColor, FontSize, FontWeight } from '@freelancer/ui/text';
import { AvatarSize } from '@freelancer/ui/user-avatar';
import { HireMeWebappModalComponent } from 'app/hire-me/hire-me-webapp-modal/hire-me-webapp-modal.component';
import { AwardProjectHireMeState, } from 'app/user-profile/user-profile-award-project.types';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';
var UserPortfolioItemOverlayComponent = /** @class */ (function () {
    function UserPortfolioItemOverlayComponent(modalService) {
        this.modalService = modalService;
        this.AvatarSize = AvatarSize;
        this.AwardProjectHireMeState = AwardProjectHireMeState;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.FontColor = FontColor;
        this.FontSize = FontSize;
        this.FontWeight = FontWeight;
        this.HeadingSize = HeadingSize;
        this.IconSize = IconSize;
        this.Margin = Margin;
        this.VerticalAlignment = VerticalAlignment;
    }
    UserPortfolioItemOverlayComponent.prototype.ngOnInit = function () {
        this.itemSkills$ = Rx.combineLatest(this.skillsCollection.valueChanges(), this.portfolioItem$).pipe(map(function (_a) {
            var skills = _a[0], item = _a[1];
            return skills.filter(function (s) { return item.jobs.includes(s.id); });
        }));
    };
    UserPortfolioItemOverlayComponent.prototype.hiremeAction = function () {
        this.modalService.close();
        this.modalService.open(HireMeWebappModalComponent, {
            inputs: {
                hireMeUser$: this.hireMeUser$,
            },
            size: ModalSize.XSMALL,
            edgeToEdge: true,
        });
    };
    return UserPortfolioItemOverlayComponent;
}());
export { UserPortfolioItemOverlayComponent };
